import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModuleVersionTestCaseRow } from "../types";

const ModuleVersionTestCasesTableStartedAtCell = ({
  item: testCase,
  ...cellProps
}: TableSimpleCellProps<ModuleVersionTestCaseRow>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Timestamp timestamp={testCase.createdAt} />
    </TableSimpleCell>
  );
};

export default ModuleVersionTestCasesTableStartedAtCell;
